import * as React from 'react';
import { SVGProps } from 'react';

const FileIconMp3SizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 34 40" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M32 0H2a2 2 0 0 0-2 2v36a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z" />
    <path
      d="M24 10.42c0 .553-.134.957-.403 1.21-.268.247-.704.37-1.308.37H21v-1h1.26c.255 0 .44-.057.56-.17.12-.12.18-.307.18-.56v-.55c0-.22-.066-.393-.2-.52a.715.715 0 0 0-.53-.2h-.958V8h.977a.733.733 0 0 0 .523-.2.696.696 0 0 0 .211-.53v-.55c0-.253-.06-.437-.18-.55-.115-.113-.3-.17-.554-.17H21V5h1.168c.57 0 1 .127 1.288.38.296.247.443.64.443 1.18v.63c0 .513-.184 1.05-.553 1.31.436.24.654.65.654 1.23v.69Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.8 7v.24c.207-.16.473-.24.8-.24h.7c.587 0 1.017.127 1.29.38.273.247.41.653.41 1.22v1.8c0 .56-.14.967-.42 1.22-.273.253-.7.38-1.28.38h-1.29v2H16V7h.8Zm.85 1c-.22 0-.383.06-.49.18a.53.53 0 0 0-.16.37l.01 2.45h1.24c.247 0 .433-.057.56-.17.127-.113.19-.273.19-.48v-1.7c0-.207-.063-.367-.19-.48-.127-.113-.313-.17-.56-.17h-.6Z"
      fill="#fff"
    />
    <path
      d="M11.5 7c.384 0 .735.144 1 .382a1.5 1.5 0 0 1 2.497 1.026L15 8.41V12h-1V8.5a.5.5 0 0 0-1 0V12h-1V8.5a.5.5 0 0 0-1 0V12h-1V7h.8v.173c.209-.11.447-.173.7-.173Z"
      fill="#fff"
    />
    <path
      opacity={0.6}
      fillRule="evenodd"
      clipRule="evenodd"
      d="m23 17-10.727 2.143v9.643h-1.637c-.903 0-1.636.72-1.636 1.607S9.733 32 10.636 32h.546c1.205 0 2.182-.96 2.182-2.143v-6.696l8.545-1.607v5.089h-1.636c-.904 0-1.637.72-1.637 1.607 0 .888.733 1.607 1.637 1.607h.545c1.205 0 2.182-.96 2.182-2.143V17Zm-1.09 2.41-8.546 1.608v1.071l8.545-1.607v-1.071Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconMp3SizeM;
